import React from "react";
import invariant from "fbjs/lib/invariant";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import permissionsMatch from "utils/permissionsMatch";

function PermissionsSwitch({ children, permissions }) {
  return (
    React.Children.map(children, child => {
      invariant(
        /WithPermissions/.test(child.type.displayName),
        "PermissionsSwitch only accepts WithPermissions as children"
      );

      if (
        permissionsMatch({
          required: child.props.required,
          oneOf: child.props.oneOf,
          permissions,
        })
      ) {
        return child;
      }
    }).find(x => x) || null
  );
}

PermissionsSwitch.defaultProps = {
  permissions: [],
};

PermissionsSwitch.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  permissions: state.user.permissions,
});

export default connect(mapStateToProps)(PermissionsSwitch);
